module.exports = __webpack_public_path__ + "static/media/illu_1@3x.81ae4bed.png";